import ReactOnRails from 'react-on-rails/client'

import AccountPage from '../Pages/Accounts'
import AccountActivationPage from '../Pages/Accounts/Activation'
import LoginPage from '../Pages/Login'

ReactOnRails.register({
  AccountPage,
  AccountActivationPage,
  LoginPage
})
